export var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["INFO"] = 0] = "INFO";
    LogLevel[LogLevel["DEBUG"] = 1] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 2] = "VERBOSE";
})(LogLevel || (LogLevel = {}));
export class Logger {
    static verbose(...args) {
        if (Logger.consoleLogging && Logger.logLevel >= LogLevel.VERBOSE)
            console.log(...args);
    }
    static debug(...args) {
        if (Logger.consoleLogging && Logger.logLevel >= LogLevel.DEBUG)
            console.log(...args);
    }
    static info(...args) {
        if (Logger.consoleLogging && Logger.logLevel >= LogLevel.INFO)
            console.log(...args);
    }
    static error(...args) {
        if (Logger.consoleLogging)
            console.error(...args);
    }
}
Logger.consoleLogging = false;
Logger.logLevel = LogLevel.VERBOSE;
